'use client'

import { Component } from 'react'

import { Spacer, Text } from '@vinted/web-ui'

import { FormattedMessage } from 'react-intl'

import { OUR_PLATFORM_URL } from 'constants/routes'

class OurPlatformDisclaimer extends Component {
  // TODO: convert into functional component
  // eslint-disable-next-line class-methods-use-this
  renderDisclaimer = () => (
    <Text
      as="h4"
      inline
      text={<FormattedMessage id="our_platform.disclaimer" />}
      type={Text.Type.Caption}
    />
  )

  // TODO: convert into functional component
  // eslint-disable-next-line class-methods-use-this
  renderDisclaimerLink = () => (
    <Text
      as="h4"
      text={
        <a href={OUR_PLATFORM_URL} target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="our_platform.disclaimer_link" />
        </a>
      }
      theme="primary"
      type={Text.Type.Caption}
    />
  )

  render() {
    return (
      <div>
        <Spacer />
        {this.renderDisclaimer()} {this.renderDisclaimerLink()}
      </div>
    )
  }
}

export default OurPlatformDisclaimer
